import e from"react";const l=({children:l,inputName:t})=>l?e.createElement("label",{htmlFor:t,className:"block font-medium"},l):null;export{l as default};
